module.exports = __webpack_public_path__ + "img/蒙版组 26.e82ee42d.png";